import { TokenPayload } from '../../../types/apis';
import { ResetPasswordSetNewPasswordData } from '../../../types/requests';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { AUTH_BASE_PATH } from '../constants/authenticationPath';

export const postResetPassword = (
  constructPost: ConstructPost,
  data: ResetPasswordSetNewPasswordData,
  headers?: Record<string, string>,
): Promise<NonPaginatedResponse<TokenPayload> | undefined> =>
  constructPost<NonPaginatedResponse<TokenPayload>>(
    `${AUTH_BASE_PATH}/password/reset`,
    { data, headers },
    { preventDefaultErrorToast: true },
  );
